import axios from 'axios';

import urls from '../../utils/urls';
import {tokenHeader} from "../../utils/headers";

export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGGED_IN_ERROR = 'USER_LOGGED_IN_ERROR';
export const USER_LOGOUT = 'USER_LOGOUT';


export function loginUser(username, password) {
    return (dispatch) => {

        const login_url = `${urls.API_ROOT}/api/v1/login/`;
        axios
            .post(login_url, {}, {auth:{username: username, password: password}})
            .then((response) => dispatch(userLoggedIn(response.data)))
            .catch((error) => dispatch(userErrorLogIn()));
    }
}

export function userLoggedIn(payload) {
    return {
        type: USER_LOGGED_IN,
        payload: payload
    };
}

export function userErrorLogIn(){
    return {
        type: USER_LOGGED_IN_ERROR
    };
}

export function userLoggedOut(){
    return {
        type: USER_LOGOUT
    };
}

export function logoutUser() {
    return (dispatch) => {
        const logout_url = `${urls.API_ROOT}/api/v1/logout/`;
        axios
            .post(logout_url, {}, tokenHeader())
            .then((response) => dispatch(userLoggedOut()))
            .catch((error) => dispatch(userLoggedOut()));
    }
}


// WEBPACK FOOTER //
// ./src/actions/user_actions/index.js